<script lang="ts">
    import {_} from 'svelte-i18n'
    import Layout from './Layout.svelte';
    import UserList from './UserList.svelte';
    import {DefinedMessageType} from './types';
    import NonHtmlDefinedMessageEditorList from './NonHtmlDefinedMessageEditorList.svelte';
    import PrimaryHtmlDefinedMessageEditorList from './PrimaryHtmlDefinedMessageEditorList.svelte';
</script>

<Layout>
    <div style="margin: 36px 50px 20px 50px;">

        <div class="user-list-block">
            <UserList />
        </div>

        <div class="mdc-typography--headline4">{$_('settings.MessagesSettings')}</div>

        <div class="defined-message-editation-block">
            <div class="mdc-typography--headline5">{$_('settings.EntryPageSettings')}</div>
            <div class="defined-message-editor-container">
                <PrimaryHtmlDefinedMessageEditorList type={DefinedMessageType.HOME_INFO} />
            </div>
        </div>

        <div class="defined-message-editation-block">
            <div class="mdc-typography--headline5">{$_('settings.EntryPageSettingsOutOfWorkHours')}</div>
            <div class="defined-message-editor-container">
                <PrimaryHtmlDefinedMessageEditorList type={DefinedMessageType.HOME_INFO_NO_OPERATOR} />
            </div>
        </div>

        <div class="defined-message-editation-block">
            <div class="mdc-typography--headline5">{$_('settings.WaitingClientMessageSettings')}</div>
            <div class="defined-message-editor-container">
                <PrimaryHtmlDefinedMessageEditorList type={DefinedMessageType.CLIENT_WAITING_ROOM_INFO} />
            </div>
        </div>

        <div class="defined-message-editation-block">
            <div class="mdc-typography--headline5">{$_('settings.NoConsultantClientMessageSettings')}</div>
            <div class="defined-message-editor-container">
                <PrimaryHtmlDefinedMessageEditorList type={DefinedMessageType.CLIENT_WAITING_ROOM_NO_OPERATOR} />
            </div>
        </div>

        <div class="defined-message-editation-block">
            <div class="mdc-typography--headline5">{$_('settings.InChatMessagesSettings')}</div>
            <div class="defined-message-editor-container">
                <NonHtmlDefinedMessageEditorList type={DefinedMessageType.OPERATOR_CHAT_MESSAGE} />
            </div>
        </div>

        <div class="defined-message-editation-block">
            <div class="mdc-typography--headline5">{$_('settings.EndChatMessagesSettings')}</div>
            <div class="defined-message-editor-container">
                <NonHtmlDefinedMessageEditorList type={DefinedMessageType.OPERATOR_CHAT_ENDING_MESSAGE} />
            </div>
        </div>
    </div>
</Layout>

<style lang="scss">
  .user-list-block {
    margin: 20px 0 20px 0;
  }

  .defined-message-editation-block {
    margin: 20px 0 20px 0;

    .defined-message-editor-container {
      margin: 10px 0 10px 0;
    }
  }
</style>